module.exports = __webpack_public_path__ + "img/inception.80a70292.svg";